import Phaser from 'phaser';

export default class Potion extends Phaser.Physics.Arcade.Sprite {
  collected = false;

  constructor(scene: Phaser.Scene, x: number, y: number, key: string) {
    super(scene, x, y, key);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.body?.setSize(8, 8);
    this.setImmovable(true);

    // 浮动动画
    this.scene.tweens.add({
      targets: this,
      y: this.y - 4,
      duration: 600,
      yoyo: true,
      repeat: -1,
    });
  }

  collect() {
    if (this.collected) return;
    this.collected = true;
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      scale: 1.5,
      duration: 300,
      onComplete: () => this.destroy(),
    });
  }
}
